<template>
  <div v-cloak>
    <main>
      <div class="container">
        <div class="row">
          <!-- Sidebar-->
          <CategoryFilter
            :categories="categories"
            v-model="filterC"
          ></CategoryFilter>
          <!-- /Sidebar end-->
          <!-- Grid -->
          <div class="products-grid col-xl-9 col-lg-8 sidebar-left">
            <div v-if="data.items.length > 0">
              <div class="row">
                <!-- item-->
                <div
                  class="item col-xl-3 col-md-6 col-6"
                  v-for="item in filteredItems"
                  :key="item.id"
                >
                  <SearchItem :item="item"></SearchItem>
                </div>
              </div>
            </div>
          </div>
          <!-- / Grid End-->
        </div>
      </div>
    </main>
    <VueEternalLoading :load="load"></VueEternalLoading>
  </div>
</template>

<script setup lang="ts">
import type Category from '../../common/Category';
import CategoryFilter from '../../components/CategoryFilter.vue';
import SearchItem from '../../components/SearchItem.vue';
import {
  VueEternalLoading,
  type LoadAction,
} from '@ts-pro/vue-eternal-loading';
import { type SearchResult } from '../../common/CatalogItem';
import { filter, intersection, isEmpty, some } from 'lodash-es';
import { computed, reactive } from 'vue';

interface Props {
  api?: string;
  categories: Category[];
  items: SearchResult[];
  pageNo: number;
  pageSize: number;
}
const props = withDefaults(defineProps<Props>(), {
  api: '',
  pageNo: 1,
});

const urlParams = new URLSearchParams(window.location.search);
// eslint-disable-next-line vue/no-setup-props-destructure
const data = reactive({
  filter: JSON.parse(urlParams.get('filter') || '{}') as Record<
    string,
    string[]
  >,
  items: props.items || [],
  pageNo: props.pageNo,
});

const filterC = computed({
  get() {
    return data.filter;
  },
  set(newValue) {
    data.filter = newValue;
    const url = new URL(window.location.toString());
    url.searchParams.set('filter', JSON.stringify(newValue));
    history.replaceState({}, '', url.toString());
  },
});

const filteredItems = computed(() => {
  if (isEmpty(filterC.value)) {
    return data.items;
  }
  let nonEmptyCategories = filter(filterC.value, function (category) {
    return category.length > 0;
  });
  //console.log(nonEmptyCategories);
  if (nonEmptyCategories.length === 0) {
    return data.items;
  }
  return filter(data.items, function (item) {
    //console.log("style:");
    //console.log(style);
    return some(nonEmptyCategories, function (selectedChildren) {
      //console.log("children:");
      //console.log(selectedChildren);
      if (selectedChildren.length === 0) return true;
      return intersection(item.categories, selectedChildren).length > 0;
    });
  });
});

async function load({ loaded, noMore }: LoadAction): Promise<void> {
  const response = await fetch(props.api + '&pageNo=' + data.pageNo);
  const { products } = await response.json();
  if (products.length) {
    data.pageNo += 1;
    data.items.push(...products);
    loaded(products.length, props.pageSize);
  } else {
    noMore();
  }
}
</script>
